import { render, staticRenderFns } from "./clientEmployeeAssociation.vue?vue&type=template&id=736f56bc&scoped=true"
import script from "./clientEmployeeAssociation.vue?vue&type=script&lang=js"
export * from "./clientEmployeeAssociation.vue?vue&type=script&lang=js"
import style0 from "./clientEmployeeAssociation.vue?vue&type=style&index=0&id=736f56bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736f56bc",
  null
  
)

export default component.exports